import { render, staticRenderFns } from "./Readings.vue?vue&type=template&id=49d1ab4d&"
import script from "./Readings.vue?vue&type=script&lang=js&"
export * from "./Readings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Readings.vue"
export default component.exports